// extracted by mini-css-extract-plugin
export default {"data-builder":"kIwQgWKOSn51rTrm711ZNQ=="};